<template>
	<div id="StepWizardBlog" class="text-left">
		<div class="title-area">
			<h4>{{ stepName }}</h4>
			<p>
				Vamos criar seus primeiros posts, escolha uma pasta de sugestão
				ou
				<strong @click="addNewItem" class="strong-click"
					>crie um novo</strong
				>
			</p>
		</div>
		<div class="input-area" v-if="countPosts > 0">
			<div class="row justify-content-center">
				<div
					class="total--item--posts col-auto p-0"
					v-for="(post, index) in totalCards"
					:key="index"
				>
					<div v-show="index == activeItem">
						<transition mode="out-in">
							<CardMinimize :cardData="post" />
						</transition>
					</div>
				</div>
			</div>
		</div>

		<div class="row justify-content-center mt-3">
			<div class="col-auto text-center overflow-hidden">
				<div
					v-for="(item, index) in totalCards"
					:key="index"
					class="label-dot-cards"
					:class="[activeItem == index ? 'active-dot' : '']"
					@click="activeItem = index"
				>
					<span></span>
				</div>
			</div>
		</div>

		<div
			class="row fixed-bottom justify-content-center"
			v-if="activeItem < totalCards.length"
		>
			<div class="col-auto">
				<button
					class="btn btn-extra-large btn-skip"
					@click="handleActiveItem('skip')"
				>
					Pular
				</button>
			</div>
			<div class="col-auto text-center">
				<button
					class="btn btn-primario btn-extra-large"
					@click="handleActiveItem('more')"
					:disabled="checkContentActiveCard"
				>
					Continuar
					<i class="fas fa-chevron-right"></i>
				</button>
			</div>
		</div>
	</div>
</template>

<script>
	import axios from "axios";
	import { Carousel3d, Slide } from "vue-carousel-3d";
	import CardMinimize from "@/components/organisms/CardMinimize";

	export default {
		name: "StepWizardBlog",
		data() {
			return {
				activeItem: 0,
				totalCards: [],
			};
		},
		props: {
			stepName: {
				type: String,
				required: false,
			},
			stepDirt:{
				type: Boolean,
				default: false,
			}
		},
		components: {
			CardMinimize,
			Carousel3d,
			Slide,
		},
		mounted() {
			this.$emit("updateStep");
			this.$store.dispatch("WIZARD_BOTTOM_BUTTONS", [false]);
			this.listCards();
		},
		methods: {
			addNewItem() {
				this.totalCards.push({
					title: "",
					contents: [],
					suggestions: [],
				});
				this.activeItem = this.totalCards.length - 1;
			},
			handleActiveItem(instruction) {
				const minimumPosts = 3;
				if(this.stepDirt == false){
					if (this.countCompletedots >= minimumPosts) {
						this.$store.dispatch("WIZARD_COMPLETE_STEP", [this.stepName]);
						this.$emit("nextStep");
					} else if (this.activeItem < this.totalCards.length - 1) {
						this.activeItem = this.activeItem + 1;
					} else {
						if (this.totalCards.length < minimumPosts) {
							if (instruction == "more") {
								this.addNewItem();
							} else {
								if(this.stepDirt == false){
									this.$store.dispatch("WIZARD_COMPLETE_STEP", [this.stepName]);
									this.$emit("nextStep");
								}
							}
						} else {
							this.$store.dispatch("WIZARD_COMPLETE_STEP", [this.stepName]);
							this.$emit("nextStep");
						}
					}
				}else{
					if (this.activeItem < this.totalCards.length - 1) {
						this.activeItem = this.activeItem + 1;
					}else{
						this.$emit("nextStep");
					}
				}
			},
			listCards() {
				if (this.stepName == "Blog") {
					this.totalCards = this.$store.state.wizard.dataSite.posts;
				} else if (this.stepName == "Novidades") {
					this.totalCards = this.$store.state.wizard.dataSite.novidades;
				} else if (this.stepName == "Serviços") {
					this.totalCards = this.$store.state.wizard.dataSite.servicos;
				} else if (this.stepName == "Portfolio") {
					this.totalCards = this.$store.state.wizard.dataSite.portfolio;
				}
				if (this.totalCards.length == 0) {
					this.addNewItem();
				}
			},
			savePosts() {
				this.$store.dispatch("TOGGLE_LOADING", [true]);
				let posts = this.totalCards;
				let siteId = localStorage.siteId;
				let token = localStorage.getItem("jwt");
				posts = JSON.stringify(posts);
				axios({
					method: "post",
					url: `${process.env.ROOT_API}api/site/${siteId}/wizard/blog/update`,
					data: { posts: posts, type: 'blog' },
					headers: {
						Authorization: "Bearer " + token,
						"Content-Type": "application/json",
					},
				}).then((response) => {
					this.$store.dispatch("SAVE_CREATED_ITEMS", [
						this.stepName,
						response.data.data,
					]);
					this.$store.dispatch("TOGGLE_LOADING", [false]);
				});
			},
		},
		computed: {
			countCompletedots() {
				return this.totalCards.filter(
					(card) =>
						card.title &&
						card.contents.some(
							(content) =>
								content.type == "image" || content.type == "script"
						)
				).length;
			},
			checkContentActiveCard() {
				if (
					this.totalCards[this.activeItem].title &&
					this.totalCards[this.activeItem].contents.some(
						(content) =>
							content.type == "image" || content.type == "script"
					)
				) {
					return false;
				}
				return true;
			},
			countPosts() {
				if (this.stepName == "Blog") {
					return this.$store.state.wizard.dataSite.posts.length;
				} else if (this.stepName == "Novidades") {
					return this.$store.state.wizard.dataSite.novidades.length;
				} else if (this.stepName == "Serviços") {
					return this.$store.state.wizard.dataSite.servicos.length;
				} else if (this.stepName == "Portfolio") {
					return this.$store.state.wizard.dataSite.portfolio.length;
				}
			},
			messageHandle() {
				if (this.stepName == "Blog" || this.stepName == "Novidades") {
					return "seus primeiros posts";
				} else {
					return "suas primeiras páginas";
				}
			},
		},
		destroyed() {
			this.$store.dispatch("UPDATE_CONTENTS", [
				this.stepName,
				this.totalCards,
			]);
			this.$store.dispatch("WIZARD_BOTTOM_BUTTONS", [true]);
			this.savePosts();
		},
	};
</script>

<style>
	.label-dot-cards {
		display: inline-block;
		cursor: pointer;
		margin: 0 4px;
	}
	.label-dot-cards span {
		background-color: #dcdcdc;
		border-radius: 50%;
		width: 8px;
		height: 8px;
		display: block;
	}
	.active-dot span {
		background-color: var(--main-color);
	}
	.carousel-3d-container {
		margin-bottom: 0px;
	}
	.list--posts {
		overflow-x: auto;
		white-space: nowrap;
		padding-bottom: 25px;
	}
	.strong-click {
		cursor: pointer;
	}

	.text-main-color {
		color: var(--main-color);
	}
</style>



// WEBPACK FOOTER //
// src/components/organisms/StepWizardBlog.vue